import _classCallCheck from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
import { Layer } from '../../engine/topology';
import { serialization, mul, add, tidy } from '@tensorflow/tfjs-core';
import { getExactlyOneTensor } from '../../utils/types_utils';
import * as K from '../../backend/tfjs_backend';
/**
 * Preprocessing Rescaling Layer
 *
 * This rescales images by a scaling and offset factor
 */
var Rescaling = /*#__PURE__*/function (_Layer) {
  _inherits(Rescaling, _Layer);
  function Rescaling(args) {
    var _this;
    _classCallCheck(this, Rescaling);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Rescaling).call(this, args));
    _this.scale = args.scale;
    if (args.offset) {
      _this.offset = args.offset;
    } else {
      _this.offset = 0;
    }
    return _this;
  }
  _createClass(Rescaling, [{
    key: "getConfig",
    value: function getConfig() {
      var config = {
        'scale': this.scale,
        'offset': this.offset
      };
      var baseConfig = _get(_getPrototypeOf(Rescaling.prototype), "getConfig", this).call(this);
      Object.assign(config, baseConfig);
      return config;
    }
  }, {
    key: "call",
    value: function call(inputs, kwargs) {
      var _this2 = this;
      return tidy(function () {
        inputs = getExactlyOneTensor(inputs);
        if (inputs.dtype !== 'float32') {
          inputs = K.cast(inputs, 'float32');
        }
        return add(mul(inputs, _this2.scale), _this2.offset);
      });
    }
  }]);
  return Rescaling;
}(Layer);
/** @nocollapse */
Rescaling.className = 'Rescaling';
export { Rescaling };
serialization.registerClass(Rescaling);